import { httpRequest } from "../../utils/HttpRequest";

export interface ILoginInfo {
    token:string,
    userInfo:Auth2UserInfo
}

export interface Auth2UserInfo {
    account?: string,   //"admin"
    branchCode?: string,   //null
    branchName?: string,   //null
    createTime?: string,   //"2022-05-20T06:28:33.453Z"
    createUser?: string,   //null
    deleteFlag?: string,   //0
    id?: string,   //"1"
    name?: string,   //null
    note?: string,   //null
    openid?: string,   //null
    orderNum?: string,   //0
    phone?: string,   //null
    staffId?: string,   //null
    status?: string,   //1
    updateTime?: string,   //"2022-05-28T02:54:37.478Z"
    updateUser?: string,   //null
}

export interface Auth2User {
    account: string;
    password: string;
    sourceApp?: string,
    token?: string
    code?: string
}

// 鉴权2.0 auth
class LoginServiceAuth2 {

    //账号密码登录  返回token
    async Login(user: Auth2User, config?: object) {
        const apiUrl = "/auth/login";
        return await httpRequest
            .post<ILoginInfo>(apiUrl, user, config);
    }
    async Logout() {
        const apiUrl = "/portal/auth/login/logout";
        return await httpRequest
            .post<string>(apiUrl);
    }
}

export const loginServiceAuth2 = new LoginServiceAuth2();
